import React from 'react'
import Tooltip from "@material-ui/core/Tooltip";
import { IconButton } from "@material-ui/core";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { SnackContext } from "../context/SnackContext";

const copyToClipboard = async (text: string): Promise<void> => {
    if (navigator.clipboard) {
        await navigator.clipboard.writeText(text);
    } else {
        const el = Object.assign(document.createElement("input"), {
            value: text,
            readOnly: true,
        });
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        el.remove();
    }
};

export const CopyFormatter = ({ row, column }) => {
    const rawValue = column && column.key ? row[column.key] : "";
    const value = rawValue == null ? "" : String(rawValue).trim();
    const snackContext = React.useContext(SnackContext);

    if (!value) return <span></span>;

    const handleCopy = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        try {
            await copyToClipboard(value);
            snackContext.updateSnack({ show: true, color: "green", message: `"${value}" copied to clipboard` });
        } catch (err) {
            snackContext.updateSnack({ show: true, color: "red", message: "Failed to copy" });
        } finally {
            setTimeout(() => snackContext.updateSnack({ show: false, color: "", message: "" }), 3000);
        }
    };

    return (
        <div style={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="Copy to clipboard">
                <IconButton size="small" onClick={handleCopy} style={{ padding: 2, marginRight: 4 }}>
                    <FileCopyIcon style={{ fontSize: 14 }} />
                </IconButton>
            </Tooltip>
            <span>{value}</span>
        </div>
    );
};